"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogMessage = exports.isAboveLevel = void 0;
const types_1 = require("../types");
/**
 * Checks if a log level is above the global log level.
 * @param level The log level to check
 * @param checkLevel THe log level to check against
 * @returns Is above the checkLevel?
 */
function isAboveLevel(level, checkLevel) {
    const levels = [types_1.LogLevel.Debug, types_1.LogLevel.Info, types_1.LogLevel.Warn, types_1.LogLevel.Error];
    return levels.indexOf(level) >= levels.indexOf(checkLevel);
}
exports.isAboveLevel = isAboveLevel;
/**
 * Ensures a message output is a string.
 * @param message The message to assert is/convert to a string
 * @returns The message as a string
 */
function getLogMessage(message) {
    if (typeof message === 'string') {
        return message;
    }
    if (typeof message === 'object' && message !== null) {
        const data = { ...message };
        return JSON.stringify(data);
    }
    return String(message);
}
exports.getLogMessage = getLogMessage;
//# sourceMappingURL=utils.js.map